import { createAction } from 'typesafe-actions';
import { ProductID } from '../Player/Product';

enum Types {
    SUBSCRIBE_BOT = 'subscribeBot',
    DISMISS_BOT = 'dismissBot',
    SWITCH_GAME = 'switchGame',
    DISMISS_CROSS_PROMO = 'dismissCrossPromo',
    ADD_SHORTCUT = 'addShortcut',
    DISMISS_SHORTCUT = 'dismissShortcut',
    PURCHASE_ITEM = 'purchaseItem',
}

export const UserActions = {
    dismissBot: createAction(Types.DISMISS_BOT),
    dismissCrossPromo: createAction(Types.DISMISS_CROSS_PROMO),
    switchGame: createAction(Types.SWITCH_GAME),
    subscribeBot: createAction(Types.SUBSCRIBE_BOT),
    addShortcut: createAction(Types.ADD_SHORTCUT),
    dismissShortcut: createAction(Types.DISMISS_SHORTCUT),
    purchaseItem: createAction(
        Types.PURCHASE_ITEM,
        resolve => (productID: ProductID) => resolve<ProductID>(productID)
    ),
};

export enum CrossPromoStatus {
    ENABLED = 'ENABLED',
    DISABLED = 'DISABLED',
    DISMISSED = 'DISMISSED',
    SWITCHED = 'SWITCHED',
}

export enum BotOptStatus {
    ENABLED = 'ENABLED',
    DISABLED = 'DISABLED',
    DISMISSED = 'DISMISSED',
    SUBSCRIBED = 'SUBSCRIBED',
}

export enum ShortcutStatus {
    ENABLED = 'ENABLED',
    DISABLED = 'DISABLED',
    DISMISSED = 'DISMISSED',
    ADDED = 'ADDED',
}
